"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const AndOptions_vue_1 = __importDefault(require("@/client/components/AndOptions.vue"));
const OrOptions_vue_1 = __importDefault(require("@/client/components/OrOptions.vue"));
const SelectAmount_vue_1 = __importDefault(require("@/client/components/SelectAmount.vue"));
const SelectCard_vue_1 = __importDefault(require("@/client/components/SelectCard.vue"));
const SelectPayment_vue_1 = __importDefault(require("@/client/components/SelectPayment.vue"));
const SelectProjectCardToPlay_vue_1 = __importDefault(require("@/client/components/SelectProjectCardToPlay.vue"));
const SelectInitialCards_vue_1 = __importDefault(require("@/client/components/SelectInitialCards.vue"));
const SelectOption_vue_1 = __importDefault(require("@/client/components/SelectOption.vue"));
const SelectPlayer_vue_1 = __importDefault(require("@/client/components/SelectPlayer.vue"));
const SelectSpace_vue_1 = __importDefault(require("@/client/components/SelectSpace.vue"));
const SelectDelegate_vue_1 = __importDefault(require("@/client/components/SelectDelegate.vue"));
const SelectParty_vue_1 = __importDefault(require("@/client/components/SelectParty.vue"));
const SelectColony_vue_1 = __importDefault(require("@/client/components/SelectColony.vue"));
const SelectProductionToLose_vue_1 = __importDefault(require("@/client/components/SelectProductionToLose.vue"));
const ShiftAresGlobalParameters_vue_1 = __importDefault(require("@/client/components/ShiftAresGlobalParameters.vue"));
const SelectGlobalEvent_vue_1 = __importDefault(require("@/client/components/SelectGlobalEvent.vue"));
const SelectResource_vue_1 = __importDefault(require("@/client/components/SelectResource.vue"));
const SelectResources_vue_1 = __importDefault(require("@/client/components/SelectResources.vue"));
const SelectClaimedUndergroundToken_vue_1 = __importDefault(require("@/client/components/SelectClaimedUndergroundToken.vue"));
const typeToComponentName = {
    'and': 'and-options',
    'card': 'SelectCard',
    'projectCard': 'SelectProjectCardToPlay',
    'initialCards': 'SelectInitialCards',
    'or': 'or-options',
    'option': 'select-option',
    'payment': 'SelectPayment',
    'space': 'select-space',
    'player': 'select-player',
    'amount': 'select-amount',
    'delegate': 'select-delegate',
    'party': 'select-party',
    'colony': 'select-colony',
    'productionToLose': 'select-production-to-lose',
    'aresGlobalParameters': 'shift-ares-global-parameters',
    'globalEvent': 'select-global-event',
    'policy': 'select-policy',
    'resource': 'select-resource',
    'resources': 'select-resources',
    'claimedUndergroundToken': 'select-claimed-underground-token',
};
exports.default = (0, vue_1.defineComponent)({
    name: 'player-input-factory',
    props: {
        players: {
            type: Array,
            required: true,
        },
        playerView: {
            type: Object,
            required: true,
        },
        playerinput: {
            type: Object,
            required: true,
        },
        onsave: {
            type: Function,
            required: true,
        },
        showsave: {
            type: Boolean,
            required: true,
        },
        showtitle: {
            type: Boolean,
            default: true,
        },
    },
    components: {
        'and-options': AndOptions_vue_1.default,
        'or-options': OrOptions_vue_1.default,
        'select-amount': SelectAmount_vue_1.default,
        SelectCard: SelectCard_vue_1.default,
        'select-option': SelectOption_vue_1.default,
        SelectPayment: SelectPayment_vue_1.default,
        SelectProjectCardToPlay: SelectProjectCardToPlay_vue_1.default,
        SelectInitialCards: SelectInitialCards_vue_1.default,
        'select-player': SelectPlayer_vue_1.default,
        'select-space': SelectSpace_vue_1.default,
        'select-delegate': SelectDelegate_vue_1.default,
        'select-party': SelectParty_vue_1.default,
        'select-colony': SelectColony_vue_1.default,
        SelectProductionToLose: SelectProductionToLose_vue_1.default,
        ShiftAresGlobalParameters: ShiftAresGlobalParameters_vue_1.default,
        SelectGlobalEvent: SelectGlobalEvent_vue_1.default,
        'select-resource': SelectResource_vue_1.default,
        'select-resources': SelectResources_vue_1.default,
        'select-claimed-underground-token': SelectClaimedUndergroundToken_vue_1.default,
    },
    methods: {
        saveData() {
            this.typedRefs.childInput.saveData();
        },
        canSave() {
            const canSave = this.typedRefs.childInput.canSave;
            return canSave ? canSave() : true;
        },
    },
    computed: {
        typedRefs() {
            return this.$refs;
        },
        componentName() {
            return typeToComponentName[this.playerinput.type];
        },
    },
});
